import { httpClient } from '../http';
import { Timezone } from './types';

export const getTimezones = async (): Promise<Timezone[]> => {
	const { data } = await httpClient.get<Timezone[]>('/customers/timezones');

	return data;
};
